import { useLocation, useNavigate } from "react-router";
import { useGetPlantationProjectDetails, useUploadPlantationCertificate } from "../../queries/project";
import Loading from "../../components/Dashboard/Loading";
import Chip from "../../components/Chip";
import MediaUpload from "../../components/Forms/MediaUpload";
import { useEffect, useState } from "react";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ProjectPlantationDetails = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const projectId = state?.projectId;
    const [certificateFile, setCertificateFile] = useState(null);
    const [certificatePreview, setCertificatePreview] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const [clearMedia, setClearMedia] = useState(false);
    const { data: projectDetails, isPending: isProjectDetailsPending } = useGetPlantationProjectDetails(projectId);
    const { mutate: uploadCertificate, isPending: isUploadingCertificate } = useUploadPlantationCertificate();
    const [disabledControl, setDisabledControl] = useState(projectDetails?.certificate === null ? false : true);
    
    const d = projectDetails;
    const cert = d?.certificate;

    useEffect(() => {
        if (projectDetails) {
            setTimeout(() => {
                setCertificateFile(projectDetails.certificate);
                setCertificatePreview(projectDetails.certificate);
                setDisabledControl(projectDetails.certificate === null ? false : true);
            }, 100);
        }
    }, [projectDetails]);

    // Simulate upload API call
    const handleCertificateUpload = async () => {
        if (!certificateFile) {
            toast.error("Please select a certificate file to upload.");
            return;
        }
        console.log('certificate: ', {
            id: d._id,
            certificate: certificateFile
        });
        uploadCertificate(
            {
                id: d._id,
                certificate: certificateFile
            },
            {
                onSuccess: (res) => {
                    if (res.error) {
                        toast.error('Certificate Upload Failed');
                        return;
                    }
                    toast.success('Certificate Uploaded Successfully');
                    setTimeout(() => {
                        navigate('/projects/plantation-project');
                    }, 2000);
                },
                onError: (error) => {
                    console.log(error);
                    toast.error('Certificate Upload Failed');
                }
            }
        );
    };

    if (isProjectDetailsPending) {
        return <Loading />;
    }

    return (
        <div className="bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] max-md:max-w-full p-3 text-base">
            <h1 className="text-primary text-xl font-bold mb-4">Project Plantation Details</h1>
            <div className="flex flex-wrap gap-5 mb-4">
                <div className="flex gap-2 basis-1/4">
                    <p className="font-semibold">Username:</p>
                    <span>{d?.userId?.username}</span>
                </div>
                <div className="flex gap-2 basis-1/4">
                    <p className="font-semibold">Email:</p>
                    <span>{d?.userId?.email}</span>
                </div>
                <div className="flex gap-2 basis-1/4">
                    <p className="font-semibold">Campaign:</p>
                    <span>{d?.campaignId?.title}</span>
                </div>
                <div className="flex gap-2 basis-1/4">
                    <p className="font-semibold">Project:</p>
                    <span>{d?.projectId?.name}</span>
                </div>
            </div>
            <div className="flex flex-wrap gap-5 mb-4">
                <div className="flex gap-2 basis-1/4">
                    <p className="font-semibold">Points Donated:</p>
                    <span>{d?.pointsDonated}</span>
                </div>
                <div className="flex gap-2 basis-1/4">
                    <p className="font-semibold">Trees Planted:</p>
                    <span>{d?.treesPlanted}</span>
                </div>
                <div className="flex gap-2 basis-1/4">
                    <p className="font-semibold">Donated At:</p>
                    <span>{d?.createdAt ? new Date(d.createdAt).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : 'N/A'}</span>
                </div>
                <div className="flex gap-2 basis-1/4">
                    <p className="font-semibold">Certificate:</p>
                    <Chip value={cert || certificatePreview ? 'Yes' : 'No'} color={cert || certificatePreview ? 'green' : 'inactive'} small={true} />
                </div>
                <div className="flex gap-2 basis-1/4">
                    <p className="font-semibold">Carbon Savings:</p>
                    <span>{d?.carbonSavings} kgs</span>
                </div>
            </div>
            <div className="my-5">
                <h2 className="text-lg font-semibold mb-2">Certificate</h2>
                {/* {cert ? (
                    <div className="flex flex-col gap-2">
                        If image/pdf, show preview or link
                        {cert.endsWith('.pdf') ? (
                            <a href={cert} target="_blank" rel="noopener noreferrer" className="text-chipBlue underline">View PDF Certificate</a>
                        ) : (
                            <img src={cert} alt="Certificate" className="w-96 h-96 object-contain rounded" />
                        )}
                    </div>
                ) : certificatePreview ? (
                    <div className="flex flex-col gap-2">
                        {certificatePreview.endsWith('.pdf') ? (
                            <a href={certificatePreview} target="_blank" rel="noopener noreferrer" className="text-chipBlue underline">View PDF Certificate</a>
                        ) : (
                            <img src={certificatePreview} alt="Certificate Preview" className="w-96 h-96 object-contain rounded" />
                        )}
                        <div className="flex items-center justify-end">
                            <button
                                className="mt-2 px-4 py-2 bg-primary text-white rounded"
                                onClick={handleCertificateUpload}
                                disabled={isUploading || isUploadingCertificate}
                            >
                                {isUploadingCertificate ? 'Uploading...' : 'Upload Certificate'}
                            </button>
                        </div>
                    </div>
                ) : ( */}
                <MediaUpload
                    label="Upload Certificate (Image)"
                    id="certificate-upload"
                    setImageUpload={setCertificateFile}
                    setStateImageUpload={setCertificateFile}
                    stateImage={certificateFile}
                    existingImage={certificateFile}
                    clearMedia={clearMedia}
                    hideBtns={disabledControl}
                    className="w-full"
                    imgClassName="w-96 h-72"
                />
                {/* )} */}
                <div className="flex items-center justify-end mt-10">
                    <button
                        className="mt-2 px-4 py-2 bg-primary text-white rounded"
                        onClick={handleCertificateUpload}
                        disabled={isUploading || isUploadingCertificate}
                    >
                        {isUploadingCertificate ? 'Uploading...' : 'Upload Certificate'}
                    </button>
                </div>
            </div>
            <ToastContainer
                position="top-right"
            />
        </div>
    );
}

export default ProjectPlantationDetails;